<template>
	<div class="all">
		<div  class="denglu_dl1">
			<div  class="denglu_dl2">
				<div  class="denglu_dl3">
					<div class="iconfont iconrenwu denglu_dl4" ></div>
					<input type="text" placeholder="请输入手机号" v-model="shu.zhanghao">
				</div>
				<div class="denglu_dl3">
					<div class="iconfont iconmima denglu_dl4" ></div>
					<input type="text" placeholder="验证码" v-model="shu.yanzhengma" class="wiinput">
					<div  class="denglu_dl10" @click="Yanzhengma">获取验证码</div>
				</div>
				<div class="denglu_dl3_">
					<div class="iconfont iconmima denglu_dl4" ></div>
					<input type="password" placeholder="请输入密码" v-model="shu.mima">
				</div>		
				<div @click="Tijiao"  class="denglu_dl6">注册</div>
				<div  class="denglu_dl7">					
					<div  class="denglu_dl8">已有账号，</div>
					<div  class="denglu_dl9">立即登录</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	var that;
	export default {
		data() {
			return {
				shu: {},
			}
		},
		created: function() {
			that = this;
		},
		methods: {
			Tijiao() {
				that.$post('k=denglu&c=zhuce', that.shu, function(s) {
					if (s.shi == 1) {					
						that.$dakai('denglu');
					} else {
						that.$message.error(s.shu);
					}
				})
			},
			Yanzhengma(){
				that.$post('k=denglu&c=yanzhengma',{zhanghao:this.shu.zhanghao}, function(s) {
					if (s.shi == 1) {
						
					} else {
						that.$message.error(s.shu);
					}
				})
			}
		}
	}
</script>

<style>
	.all {
		background: url(../../assets/denglu.png)no-repeat;
		background-size: cover;
		width: 100%;
		height: 100vh;
		position: relative;
	}

	input {
		background: none;
		outline: none;
		border: none;
	}
	.wiinput{width: 56%;}
.denglu_dl1{width:500px;height:400px;background:rgba(255,255,255,1);border-radius:30px;box-shadow:0px 0px 10px 0px rgba(224,224,224,1);position: absolute; margin-top: -200px;top: 50%;left: 50%;margin-left: -250px;}
.denglu_dl2{padding:57px  74px 0 83px ;}
.denglu_dl3{height: 60px;display: flex;border-bottom: 1px solid #EBEBEB;align-items: center;width: 320px;}
.denglu_dl3_{height: 60px;display: flex;border-bottom: 1px solid #EBEBEB;align-items: center;width: 320px;margin-bottom: 30px;}
.denglu_dl4{color: #00BFFF;font-size: 15px;padding-right: 19px;}
.denglu_dl5{height: 60px;display: flex;align-items: center;width: 320px;}
.denglu_dl6{width:360px;height:40px;background:rgba(0,123,255,1);border:1px solid rgba(26,114,254,1);border-radius:34px;display: flex;align-items: center;justify-content: center;margin: 0 auto;font-size:14px;color:rgba(255,255,255,1);font-weight:400;}
.denglu_dl7{display: flex;justify-content: center;padding-top: 20px;}
.denglu_dl8{font-size:9px;font-weight:400;color:rgba(153,153,153,1);}
.denglu_dl9{color: #007BFF;font-size:9px;font-weight:400;}
.denglu_dl10{display: flex;align-items: center;justify-content: center;color:rgba(0,123,255,1);font-weight:400;font-size:16px;border-radius:7px;border:1px solid rgba(0,123,255,1);height:25px;width:100px;}


</style>
